import ProfessionalCredit from './ProfessionalCredit'

import {
  Container,
  SubTitle,
  LabelRow,
  InfoText
} from './styles'

export default function ProfessionalCreditList ({
  credits = [],
  type,
  styles,
  onEdit: handleEdit,
  onDelete: handleDelete
}) {
  if (credits.length === 0) return (
    <Container style={styles}>
      <InfoText>
        Nenhum {type === 'bonus' ? 'bônus' : 'desconto'} encontrado
      </InfoText>
    </Container>
  )

  return (
    <Container style={styles}>
      <LabelRow>
        <SubTitle>Data</SubTitle>
        <SubTitle>Descrição</SubTitle>
        <SubTitle>Valor</SubTitle>
        <SubTitle>Ações</SubTitle>
      </LabelRow>
      {credits.map (credit => (
        <ProfessionalCredit
          key={credit.id}
          data={credit}
          type={type}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      ))}
    </Container>
  )
}
